/**
 * Enumeration of the different export sources
 */ export var ExportOperationSource = /*#__PURE__*/ function(ExportOperationSource) {
    /** Not a valid operation type */ ExportOperationSource[ExportOperationSource["Invalid"] = 0] = "Invalid";
    /**
     * Export a plan and all its contents
     */ ExportOperationSource[ExportOperationSource["Plan"] = 1] = "Plan";
    return ExportOperationSource;
}({});
/**
 * Enumeration of the different export formats
 */ export var ExportOperationFormat = /*#__PURE__*/ function(ExportOperationFormat) {
    /** Not a valid export  format */ ExportOperationFormat[ExportOperationFormat["Invalid"] = 0] = "Invalid";
    /** Export to an Excel document */ ExportOperationFormat[ExportOperationFormat["Excel"] = 1] = "Excel";
    return ExportOperationFormat;
}({});
